import AddToCalendar from "./lobby/details/actions/add-to-calendar/AddsToCalendar";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { RsvpButton } from "@kaltura/mediaspace-shared-entry";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import { KalturaBaseEntry } from "kaltura-typescript-client/api/types/KalturaBaseEntry";

interface AddToCalendarContainerProps {
    entry: KalturaBaseEntry;
    size?: "large" | "medium";
}

/**
 * wrapper for AddToCalendar component
 * for reuse in all hero components
 */
const AddToCalendarContainer = (props: AddToCalendarContainerProps) => {
    const { entry, size } = props;
    const config = useConfig();

    return !config.rsvp?.isCrossSite ? (
        <AddToCalendar
            sessionId={entry.id}
            textProps={{
                addToCalendarActionText: translate("Add To Calendar"),
                addToCalendarAddedText: "",
            }}
            collapseToIconBreakpoint={"sm"}
            translucent={true}
            size={size}
        />
    ) : (
        <RsvpButton
            entry={entry}
            size={size}
            allowResendPostRsvp={config.application.isLoggedIn}
            fetchStatusOnMount={config.application.isLoggedIn}
            analyticsValue={{ location: "Media Hero" }}
        />
    );
};

export default AddToCalendarContainer;
